import { CookieConcentHandler } from 'common/handlers/CookieConcentHandler';
import { useUserSession } from 'common/stores/UserSessionStore';
import { Outlet, useLocation } from 'react-router-dom';
import { Analytics } from 'common/stores/Analytics';
import React, {  useEffect } from 'react';
import {
    GOOGLE_ANALYTICS_MESSAGING_SENDER_ID,
    GOOGLE_ANALYTICS_STORAGE_BUCKET,
    GOOGLE_ANALYTICS_MEASUREMENT_ID,
    GOOGLE_ANALYTICS_AUTH_DOMAIN,
    GOOGLE_ANALYTICS_PROJECT_ID,
    GOOGLE_ANALYTICS_API_KEY,
    GOOGLE_ANALYTICS_APP_ID
} from 'assets/configurations/envConfigs';



let analyticsInstance = null;
const { initializeApp } = await import(
    /* webpackChunkName: "firebase-app" */'firebase/app');
const firebaseAnalyticsLib = await import(
    /* webpackChunkName: "firebase-analytics" */'firebase/analytics');

function checkUserAcceptance() { return CookieConcentHandler.check({ acceptance: 'accept', categories: ['performance'] }) };

function googleAnalyticsSettings() {
    return { 
        "messagingSenderId": GOOGLE_ANALYTICS_MESSAGING_SENDER_ID,
        "storageBucket": GOOGLE_ANALYTICS_STORAGE_BUCKET,
        "measurementId": GOOGLE_ANALYTICS_MEASUREMENT_ID,
        "authDomain": GOOGLE_ANALYTICS_AUTH_DOMAIN,
        "projectId": GOOGLE_ANALYTICS_PROJECT_ID,
        "apiKey": GOOGLE_ANALYTICS_API_KEY,
        "appId": GOOGLE_ANALYTICS_APP_ID
    }
};

function identifyUser({ account }) {
    const { uid = '' } = account || {};

    analyticsInstance = firebaseAnalyticsLib.getAnalytics(
        initializeApp(googleAnalyticsSettings()));
    
    firebaseAnalyticsLib.setUserId(analyticsInstance, uid);
    firebaseAnalyticsLib.setUserProperties(analyticsInstance, {});
};


export function AnalyticsComponent() {
    const { getLeapAccount } = useUserSession();
    const location = useLocation();

    useEffect(() => {
        sendPageview();
    }, [location]);

    async function sendPageview() {
        const userAcceptance = checkUserAcceptance();

        if(!userAcceptance) {
			return;
		};

        if(!analyticsInstance) {
			identifyUser({ account: getLeapAccount() });
		};
  
        const { href = '', pathname = '' } = self.location || {};
        const { title = '', referrer = '' } = self.document || {};
		
        firebaseAnalyticsLib.logEvent(analyticsInstance, 'page_view', { 
            page_referrer: referrer,
			app_module: 'Orff Hero',
            page_path: pathname,
            page_location: href,
			page_title: title,
			mode: 'ONLINE'
		});
    };

    function sentEvent() {
        return
    };

    return (
        <Analytics.Provider value={{ sentEvent }}>
            <Outlet />
        </Analytics.Provider>
    );
};